import React, { forwardRef, useImperativeHandle, useRef } from 'react'

import LottieView from 'lottie-react-native'
import styled from 'styled-components/native'

import splashOrb from '../../assets/lottie/SplashOrb.json'
import { IS_CYPRESS } from '../../constants'
import { tID } from '../../utils/utils'

const Container = styled.View<{ width: number | string; height: number | string }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

export interface SplashOrbHandle {
  play: () => void
  reset: () => void
}

export interface SplashOrbProps {
  width?: number
  height?: number
  shouldAutoplay?: boolean
}

export const SplashOrb = forwardRef<SplashOrbHandle, SplashOrbProps>(
  ({ width = 393, height = 852, shouldAutoplay = true }, ref) => {
    const animationRef = useRef<LottieView>(null)
    const effectiveWidth = width + 1
    const effectiveHeight = height + 1
    const onPlay = () => {
      if (IS_CYPRESS) {
        return
      }
      animationRef.current?.play()
    }

    useImperativeHandle(ref, () => ({
      play: onPlay,
      reset: () => {
        animationRef.current?.reset()
      },
    }))

    return (
      <Container width={effectiveWidth} height={effectiveHeight} testID={tID('SplashOrb')}>
        <LottieView
          ref={animationRef}
          source={splashOrb}
          loop={false}
          autoPlay={shouldAutoplay}
          style={{ width: effectiveWidth, height: effectiveHeight }}
          resizeMode='cover'
        />
      </Container>
    )
  },
)
